import dataEN from './locales/en.json' assert { type: 'json' };
import dataFR from './locales/fr.json' assert { type: 'json' };

export async function loadTranslations(lang = 'fr') {
  return lang === 'en' ? dataEN : dataFR;
}

export const breakpoints = {
  xs: 480,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1440,
  '2xl': 1920,
  '3xl': 2560
};

const youtubeReadyCallbacks = [];
let youtubeApiLoading = false;

export function whenYouTubeReady(callback) {
  //API prête
  if (window.YT && window.YT.Player) {
    callback();
    return;
  }

  // API pas prête
  youtubeReadyCallbacks.push(callback);

  // Une seule callback globale
  window.onYouTubePlayerAPIReady = () => {
    youtubeReadyCallbacks.forEach((cb) => cb());
    youtubeReadyCallbacks.length = 0;
  };

  loadYouTubeAPI();
}

export function loadYouTubeAPI() {
  const url = 'https://www.youtube.com/player_api';

  if (document.querySelector(`script[src="${url}"]`) || youtubeApiLoading) {
    return;
  }

  youtubeApiLoading = true;

  const tag = document.createElement('script');
  tag.src = url;

  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
